/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderVoucher
 */
export interface OrderVoucher {
    /**
     * 
     * @type {number}
     * @memberof OrderVoucher
     */
    orderId?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderVoucher
     */
    voucherId?: number;
    /**
     * 
     * @type {Date}
     * @memberof OrderVoucher
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof OrderVoucher
     */
    updatedAt?: Date;
}

export function OrderVoucherFromJSON(json: any): OrderVoucher {
    return OrderVoucherFromJSONTyped(json, false);
}

export function OrderVoucherFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderVoucher {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'orderId': !exists(json, 'orderId') ? undefined : json['orderId'],
        'voucherId': !exists(json, 'voucherId') ? undefined : json['voucherId'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}

export function OrderVoucherToJSON(value?: OrderVoucher | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'orderId': value.orderId,
        'voucherId': value.voucherId,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}


